import * as React from 'react';
import { styled } from '@glitz/react';
import { createMinLargeViewportDecorator } from './viewport';

type PropType = {
  label: string;
  small?: boolean;
  alignRight?: boolean;
  onClick?: () => void | undefined;
  onMouseEnter?: () => void | undefined;
  onMouseLeave?: () => void | undefined;
};

export const EnergyLabel = styled(
  ({
    label,
    small = false,
    alignRight = false,
    onClick = undefined,
    onMouseEnter = undefined,
    onMouseLeave = undefined,
  }: PropType) => {
    const colorDecorator = styled({
      backgroundColor: getEnergyLabelColor(label),
      ':before': {
        border: {
          right: { color: alignRight ? getEnergyLabelColor(label) : 'transparent' },
          left: { color: alignRight ? 'transparent' : getEnergyLabelColor(label) },
        },
      },
    });

    const smallSizeDecorator = styled(
      createMinLargeViewportDecorator({
        width: 48,
        height: 16,
        fontSize: t => t.sharedFontSize.xxs,
      }),
      {
        width: 30,
        height: 12,
        fontSize: t => t.sharedFontSize.xxxs,
      },
    );

    const largeSizeDecorator = styled({
      width: 50,
      height: 22,
    });

    const sizeDecorator = small ? smallSizeDecorator : largeSizeDecorator;

    const alignmentDecorator = styled({
      justifyContent: alignRight ? 'flex-end' : 'flex-start',
      clipPath: alignRight
        ? 'polygon(22% 0%, 100% 0%, 100% 100%, 22% 100%, 0% 50%)'
        : 'polygon(0% 0%, 78% 0%, 100% 50%, 78% 100%, 0% 100%)',
    });

    return (
      <EnergyIcon
        css={styled(colorDecorator, sizeDecorator, alignmentDecorator)}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {label}
      </EnergyIcon>
    );
  },
);

const EnergyIcon = styled.div({
  padding: { x: t => t.sharedSpacing.xxs },
  display: 'flex',
  alignItems: 'center',
  color: 'white',
  lineHeight: 'normal',
  fontWeight: 'bold',
  cursor: 'pointer',
});

const getEnergyLabelColor = (energyLabel: string) => {
  switch (energyLabel) {
    case 'A':
      return '#00a651';
    case 'B':
      return '#50b848';
    case 'C':
      return '#bfd730';
    case 'D':
      return '#fff200';
    case 'E':
      return '#fdb913';
    case 'F':
      return '#f37021';
    case 'G':
      return '#ed1c24';
    default:
      return 'white';
  }
};
